(() => {
  const mobileQuery = window.matchMedia('(max-width: 699px)');
  const actionButtonIds = [
    'shopify-pc__banner__btn-accept',
    'shopify-pc__banner__btn-decline',
    'shopify-pc__prefs__header-save',
    'shopify-pc__prefs__header-accept',
    'shopify-pc__prefs__header-decline'
  ];

  function enhanceActionButton(button) {
    if (!button || button.dataset.lonevileButtonEnhanced === 'true') return;

    const label = button.textContent.trim();
    if (!label) return;

    const content = document.createElement('button-content');
    content.className = 'button__content';
    content.setAttribute('up-text', label);
    content.textContent = label;

    button.replaceChildren(content);
    button.classList.add('button', 'lonevile-cookie-action');
    button.dataset.lonevileButtonEnhanced = 'true';
  }

  function enhanceCloseButton(button) {
    if (!button || button.dataset.lonevileCloseEnhanced === 'true') return;

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('width', '10');
    svg.setAttribute('viewBox', '0 0 10 10');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('class', 'icon icon-close');

    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('d', 'm1 1 8 8m0-8L1 9');

    svg.append(path);
    button.replaceChildren(svg);
    button.classList.add('lonevile-cookie-close');
    button.dataset.lonevileCloseEnhanced = 'true';
  }

  function setOptionExpanded(option, expanded) {
    const trigger = option.querySelector('.lonevile-cookie-accordion');
    const description = option.querySelector(':scope > p');
    if (!trigger || !description) return;

    const isMobile = mobileQuery.matches;
    const isExpanded = isMobile ? expanded : true;

    option.dataset.lonevileExpanded = String(expanded);
    option.classList.toggle('is-open', isMobile && expanded);
    trigger.setAttribute('aria-expanded', String(isExpanded));
    trigger.tabIndex = isMobile ? 0 : -1;
    description.hidden = !isExpanded;
  }

  function enhancePreferences(dialog) {
    const options = Array.from(dialog.querySelectorAll('.shopify-pc__prefs__option'));

    options.forEach((option, index) => {
      if (option.dataset.lonevileAccordionEnhanced !== 'true') {
        const label = option.querySelector(':scope > label');
        const description = option.querySelector(':scope > p');
        const titleNode = label
          ? Array.from(label.childNodes).find(
              node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
            )
          : null;

        if (!label || !description || !titleNode) return;

        const title = titleNode.textContent.trim();
        const descriptionId = `${option.id || `lonevile-cookie-option-${index}`}-description`;
        const trigger = document.createElement('button');

        trigger.type = 'button';
        trigger.className = 'lonevile-cookie-accordion';
        trigger.textContent = title;
        trigger.setAttribute('aria-controls', descriptionId);

        description.id = descriptionId;
        titleNode.remove();
        label.setAttribute('aria-label', title);
        option.insertBefore(trigger, label);
        option.dataset.lonevileAccordionEnhanced = 'true';
        option.dataset.lonevileExpanded = String(index === 0);

        trigger.addEventListener('click', () => {
          if (!mobileQuery.matches) return;

          const shouldOpen = option.dataset.lonevileExpanded !== 'true';
          options.forEach(otherOption => setOptionExpanded(otherOption, false));
          setOptionExpanded(option, shouldOpen);
        });
      }

      setOptionExpanded(option, option.dataset.lonevileExpanded === 'true');
    });

    dialog.classList.add('lonevile-cookie-enhanced');
  }

  function enhanceCookieUi() {
    actionButtonIds.forEach(id => enhanceActionButton(document.getElementById(id)));
    enhanceCloseButton(document.getElementById('shopify-pc__prefs__header-close'));

    const dialog = document.getElementById('shopify-pc__prefs__dialog');
    if (dialog) enhancePreferences(dialog);
  }

  const observer = new MutationObserver(enhanceCookieUi);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCookieUi, { once: true });
  } else {
    enhanceCookieUi();
  }

  observer.observe(document.documentElement, { childList: true, subtree: true });
  mobileQuery.addEventListener('change', enhanceCookieUi);
})();
